import { ContentDifficulty } from '../types/base';

export const DIFFICULTIES = Object.values(ContentDifficulty);

export const DIFFICULTY_DISPLAY_NAMES: Record<ContentDifficulty, string> = {
  [ContentDifficulty.VERY_EASY]: 'Very Easy',
  [ContentDifficulty.EASY]: 'Easy',
  [ContentDifficulty.MODERATE]: 'Moderate',
  [ContentDifficulty.DIFFICULT]: 'Difficult',
  [ContentDifficulty.VERY_DIFFICULT]: 'Very Difficult'
};

export const DIFFICULTY_COLORS: Record<ContentDifficulty, string> = {
  [ContentDifficulty.VERY_EASY]: 'green',
  [ContentDifficulty.EASY]: 'cyan',
  [ContentDifficulty.MODERATE]: 'blue',
  [ContentDifficulty.DIFFICULT]: 'orange',
  [ContentDifficulty.VERY_DIFFICULT]: 'red'
};